import type {
  FiltroDeLaLista,
  FuenteDeLaLista,
} from '@/features/pricing-rules/components/selector-de-productos';
import { strategyApplicationsApi } from '../../services/strategy-applications-api';
import type { GroupDraft } from '../../types/strategy-applications.types';

/**
 * «Elegir de la lista…» en el asistente (plan 3, Tarea 5b · P3-D12): la lista
 * sale de `POST /api/strategy-applications/productos`, la misma resolución del
 * alcance que la corrida. Una estrategia no tiene acciones: `/pricing-rules/simular`
 * (la fuente de Reglas) le daría 400.
 */

/** Productos puntuales: se elige de todo el catálogo activo. */
export const TODO_EL_CATALOGO: GroupDraft = { name: 'Borrador', kind: 'DYNAMIC', filter: {} };

const igual = (a: string, b: string) => a.localeCompare(b, 'es', { sensitivity: 'base' }) === 0;

/**
 * La categoría y la marca que se eligen en la lista, DENTRO del alcance: acotan,
 * nunca agrandan. `null` = no queda nadie (una categoría que el alcance no tiene).
 */
export function grupoConFiltroDeLaLista(g: GroupDraft, f: FiltroDeLaLista): GroupDraft | null {
  if (g.kind !== 'DYNAMIC' || (!f.category && !f.brand)) return g;
  const filtro: Record<string, unknown> = { ...(g.filter ?? {}) };
  const pares: Array<['categories' | 'brands', string | undefined]> = [
    ['categories', f.category],
    ['brands', f.brand],
  ];
  for (const [clave, elegido] of pares) {
    if (!elegido) continue;
    const delAlcance = filtro[clave];
    if (
      Array.isArray(delAlcance) &&
      delAlcance.length > 0 &&
      !delAlcance.some((x) => igual(String(x), elegido))
    ) {
      return null;
    }
    filtro[clave] = [elegido];
  }
  return { ...g, filter: filtro };
}

export function fuenteDelAlcance(g: GroupDraft): FuenteDeLaLista {
  return {
    clave: JSON.stringify(g),
    pedir: async (filtro, page, limit) => {
      const grupo = grupoConFiltroDeLaLista(g, filtro);
      if (!grupo) return { total: 0, filas: [] };
      const r = await strategyApplicationsApi.productosDelAlcance(grupo, page, limit, filtro.q);
      return {
        total: r.total,
        filas: r.productos.map((p) => ({
          sku: p.sku,
          name: p.name,
          category: p.category,
          brand: p.brand,
          precioHoy: p.currentPrice,
        })),
      };
    },
  };
}
